<script setup>
import { computed } from "vue"
import { shipTypes, shipsTypes2 } from "../staticData"
import { storage } from '../storage'
import MiniAlien from './Alien/MiniAlien'
import SpaceBarElement from './SpaceBarElement'
defineProps(['aliens'])
const emits = defineEmits(['space-mouse-click'])

// const aliens = computed(() => {
//     let num = props.aliens
//     // console.log('NUM ORiNINAL', num)
//     const res = []
//     if (num === 0) return res;

//     aliensTypes.forEach(n => {
//         if (num / n >= 1) {
//             const amount = Math.floor(num / n)
//             // console.log('NUM before', num, 'AM', amount)
//             for (let i = 0; i < amount; i++)
//                 res.push({ type: n })
//             num -= amount * n
//             // console.log('NUM after', num,)

//         } else return;

//     });
//     return res;
// })


let fadeOut = null;
function barClick(isNew) {
    emits('space-mouse-click', isNew)
    if (fadeOut) clearTimeout(fadeOut)

    storage.GLOW_ON = true
    fadeOut = setTimeout(() => storage.GLOW_ON = false, 400)
}
document.addEventListener('keydown', function (event) {
    if (storage.ADD_ON === false && event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        if (!event.repeat) barClick(true)
        // else barClick(false)
    }
});

const spaceUrl = computed(() => {
    if (storage.CURRENT_SHIP && storage.CURRENT_SHIP !== 'spacebar') {
        return `/spacebar-clicker/assets/spacebars/${shipsTypes2[storage.CURRENT_SHIP].imgUrl}`
    }
    else return null
})


const getMarginTop = () => {
    const margin = shipsTypes2[storage.CURRENT_SHIP].marginTop
    if (window.innerWidth > 1000) return margin
    else return `calc(${margin} / 2)`
}

const barPosition = computed(() => spaceUrl.value ? window.innerHeight >= 500 ? { bottom: '0', top: '40%' } : { bottom: '10px', top: 'unset' } : { bottom: '100px', top: 'unset' })
// const barPosition = computed(() => spaceUrl.value ? { bottom: '0', top: '40%' } : { bottom: '100px', top: 'unset' })
// const barTopPosition = computed(() => spaceUrl.value ? '40%' : 'unset')
</script>

<template>
    <div id="space-ship-wrap" @click="barClick">
        <div id="space-ship">
            <div class="alien-wrap" >
                <MiniAlien v-for="a in storage.ALIENS_OWNED" :key="a + '-alien'" :alien="a" />
            </div>
            <p class="ship-name">SpaceBar Ship</p>
            <p class="ship-level">L {{ shipTypes[storage.UPGRADES_LVLS.ships].id }}</p>
        </div>
        <div id="down-part" :class="{ 'glow-on': storage.GLOW_ON }">
            <img v-if="spaceUrl" :src="spaceUrl" id="ship-img" alt="" 
            :style="{
                'margin-top': getMarginTop(),
                'margin-left': shipsTypes2[storage.CURRENT_SHIP].marginLeft
            }">
            <SpaceBarElement v-else :classes="'main'"/>
        </div>
    </div>
   </template>

<style scoped>
#space-ship-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
    width: 500px;
    height: fit-content;
    overflow: visible;
    animation: floatAnimation 2s infinite alternate linear;
}

#space-ship-wrap:hover {
    cursor: pointer;
}

#space-ship {
    position: relative;
    width: 100%;
    height: 250px;
    /* border: 5px solid white; */
    border-top-left-radius: 250px;
    border-top-right-radius: 250px;
    box-shadow: inset 0 0 20px 20px white;
    background-color: #b1b1f857;
    z-index: 10;
}

#down-part {
    position: relative;
    z-index: 5;
    transform: translate(-10%, -50%);
    width: 120%;
    height: fit-content;
    overflow: visible;
    /* margin-bottom: v-bind(imgHeight); */
}

#down-part.glow-on img {
    /* box-shadow: -2px -1px 3rem 2.5rem hsl(186 100% 69%); */
    filter: drop-shadow(0 0 2.5rem hsl(186 100% 69%)) drop-shadow(0 0 2.5rem hsl(186 100% 69%));
}

#down-part.glow-on #space-bar {
    /* box-shadow: -2px -1px 3rem 2.5rem hsl(186 100% 69%); */
    filter: drop-shadow(0 0 2.5rem hsl(186 100% 69%)) drop-shadow(0 0 2.5rem hsl(186 100% 69%));
}

#down-part img {
    /* height: 100%; */
    transition: filter 0.5s ease-in-out;
    width: 100%;
    /* position: relative; */
    /* transform: translate(-10%, -50%); */
}

#space-ship p {
    position: absolute;
    color: black;
}

.ship-name {
    width: 100%;
    text-align: center;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    letter-spacing: 10px;
    font-size: 2rem;
}

.ship-level {
    right: 10px;
    bottom: 0;
    /* transform: translateY(-50%); */

}

.alien-wrap {
    position: relative;
    /* background-color: red; */
    /* bottom: 10px; */
    /* left: 10px; */
    /* transform: skew(35deg, 0deg); */
    background-color: transparent;
    /* display: flex; */
    width: 100%;
    height: 100%;
    /* align-items: flex-end; */
}

@keyframes floatAnimation {
    0% {
        transform: translateX(-50%) rotate(8deg);
    }

    100% {
        transform: translateX(-50%) rotate(-8deg);
    }

}



@media (min-height: 551px) and (max-height: 700px) {
    #space-ship-wrap {
        top: v-bind('barPosition.top');
        bottom: v-bind('barPosition.bottom');
        /* width: 300px; */
        /* transform: translateX(-50%); */
        /* width: 500px; */
        max-height: 280px;
    }
}

@media (max-height: 550px) {
    #space-ship-wrap {
        top: v-bind('barPosition.top');
        bottom: v-bind('barPosition.bottom');
        width: 350px;
        max-height: 280px;
    }

    #space-ship {
        height: 200px;
    }

    .ship-name {
        width: 90%;
    }
}

@media (max-height: 300px) {

    #space-ship-wrap {
        width: 280px;
        max-height: 250px;
    }

    #space-ship {
        height: 180px;
    }

    #space-ship p {
        font-size: 1.3rem;
    }

    .ship-name {
        width: 90%;
    }
}
</style>